import React from 'react';
import { FormProvider } from './context/Form.context';
import Form from './Form';
import { FormProps } from './types';

const FormComponent: React.FC<FormProps> = ({
	initialValues,
	children,
	...props
}) => {
	const initialState = {
		values: initialValues || {},
		validationMessages: {},
		invalidFields: [],
	};

	return (
		<FormProvider initialState={initialState}>
			<Form initialValues={initialValues || {}} {...props} className='flex flex-col gap-12 py-8 px-4 rounded-md border border-black/30'>
				{children}
			</Form>
		</FormProvider>
	);
};

export default FormComponent;
